import React from 'react';
import styled from 'styled-components';
import HeroImageReel from './ImageReel';
// import {Animated} from 'react-animated-css';
// import {useTrail, animated} from 'react-spring';

const HeroTextWrapper = styled.div`
	@media screen and (min-width: 640px) {
		padding: 50px 0 0;
	}
`;

const HeroText = styled.div`
	@media screen and (min-width: 768px) {
		width: 45%;
	}
`;

const HeroHeading = styled.h1`
	margin-bottom: 1em;
	text-transform: uppercase;
	overflow: hidden;

	@-webkit-keyframes textSlide {
		0% {
			transform: translateY(200px);
		}
		100% {
			transform: translateY(0);
		}
	}

	@keyframes textSlide {
		0% {
			transform: translateY(200px);
		}
		100% {
			transform: translateY(0);
		}
	}

	span {
		display: inline;
		&:first-of-type {
			animation: textSlide 0.7s ease;
		}
		&:nth-of-type(2n) {
			animation: textSlide 1s ease;
		}
		&:nth-of-type(3n) {
			animation: textSlide 1.2s ease;
		}
		&:nth-of-type(4n) {
			animation: textSlide 1.5s ease;
		}
	}

	@media screen and (min-width: 640px) {
		margin-bottom: 0.5em;
		display: inline-block;
	}
`;

const HeroSubHeading = styled.div`
	margin-bottom: 0.5em;
	overflow: hidden;

	p {
		animation: textSlideFade 2s ease;
	}

	em {
		color: #949076;
	}

	@-webkit-keyframes textSlideFade {
		0% {
			// transform: translateY(100px);
			opacity: 0;
		}
		100% {
			// transform: translateY(0);
			opacity: 1;
		}
	}

	@keyframes textSlideFade {
		0% {
			// transform: translateY(100px);
			opacity: 0;
		}
		100% {
			// transform: translateY(0);
			opacity: 1;
		}
	}
`;

const HeroContent = () => {
	return (
		<section id="intro">
			<div className="container">
				<HeroTextWrapper>
					<HeroText>
						<HeroHeading>
							<span>Project SafeUp: </span>
							<span>Producing Free </span>
							<span>COVID-19 Relief For </span>
							<span>Nigerians</span>
						</HeroHeading>
						<HeroSubHeading>
							<p>
								In partnership the Mastercard Foundation,{' '}
								<a href="http://myworldofbags.com/" target="_blank" rel="noreferrer">
									<em>My World of Bags (MWOB)</em>
								</a>{' '}
								set up an initiative called Project SafeUp, with the aim of helping Nigerians across the country
								amidst the ongoing pandemic and championing health and safety for the general public.
							</p>
						</HeroSubHeading>
					</HeroText>
					{/* <ExploreButton>Explore</ExploreButton> */}
				</HeroTextWrapper>
			</div>
			<HeroImageReel />
		</section>
	);
};

export default HeroContent;
